import { AttributeTypeEnum, OperatorsEnum } from '@celito.clients/enums';
import { ObjectAttributeType } from '@celito.clients/types';
import { BaseEntityWithName } from 'apps/web-client/src/types/base-entity';
import { GetSearchParamsFunc } from 'libs/core/src/hooks/useQueryParams';
import { RulesComponentListViewFilter } from 'libs/shared/src/lib/rules-component/types/rules-component.types';

import { SortConfig, View } from '../types';

export const getDefaultFiltersAndRecordData = (
  viewData: View | undefined,
  rawColumnData: ObjectAttributeType | null,
  getSearchParams: GetSearchParamsFunc,
  relatedChildRecords: BaseEntityWithName[]
) => {
  const defaultFilters = viewData?.filterViews?.find(
    (filters) => filters.isDefault
  )?.filtersToBeApplied[0];

  let defaultSortConfig: SortConfig | undefined;
  if (viewData?.defaultSortColumn && viewData?.defaultSortOrder) {
    defaultSortConfig = {
      attribute: viewData.defaultSortColumn,
      order: viewData.defaultSortOrder,
    };
  }

  let recordData: RulesComponentListViewFilter | undefined;

  const params = getSearchParams();
  const recordName = params?.recordname;
  const objectName = params?.objectname;

  if (recordName && objectName) {
    const recortAttributeName = rawColumnData?.objectAttributeDefinitions.find(
      (item) => item.dataType === AttributeTypeEnum.Record
    )?.name;
    const objectAttributeName = rawColumnData?.objectAttributeDefinitions.find(
      (item) => item.dataType === AttributeTypeEnum.ObjectDefinition
    )?.name;

    const relationsWithParent = [
      {
        name: recordName,
        objectDefinitionName: objectName,
      },
      ...relatedChildRecords,
    ];

    if (recortAttributeName && objectAttributeName) {
      recordData = {
        conditions: {
          any: relationsWithParent.map((record) => {
            return {
              all: [
                {
                  attribute: recortAttributeName,
                  operator: OperatorsEnum.EQUALS,
                  value: {
                    recordName: record.name,
                    objectName: record.objectDefinitionName,
                  },
                },
                {
                  attribute: objectAttributeName,
                  operator: OperatorsEnum.EQUALS,
                  value: record.objectDefinitionName,
                },
              ],
            };
          }),
        },
      };
    }
  }

  return {
    defaultFilters,
    recordData,
    defaultSortConfig,
  };
};
